import { NgIf } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { SelectableOption } from '@models/selectable-option';
import { ConsultationStorageService } from '@services/consultation-storage.service';

@Component({
  selector: 'app-alleviate-nausea-and-vomiting',
  templateUrl: './alleviate-nausea-and-vomiting.component.html',
  imports: [UpsellCardComponent, NgIf],
})
export class AlleviateNauseaAndVomitingComponent {
  @Input() public htmlTitle: string = '<strong>Important: Alleviate</strong> Nausea and Vomiting';
  public question: string =
    'We strongly recommend including Zofran in your prescription. Would you like to add it to your treatment plan?';
  public ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;
  public readonly slug: UpsellSlugs = UpsellSlugs.OndansetronPill;
  public readonly options: SelectableOption[] = [
    new SelectableOption('Yes, add Zofran in pill form', this.slug),
    new SelectableOption(
      'Yes, add Zofran in sublingual dissolvable tablet form',
      UpsellSlugs.OndansetronDissolvableTablet,
    ),
    new SelectableOption("No, I don't want to include Zofran", QuestionnaireAnswers.No),
  ];

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Retrieves the treatment type from the local storage service.
   *
   * @returns {ConsultationTreatmentTypes} the current consultation request treatment type
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
